import { render } from "./FluxoAprovacao.vue?vue&type=template&id=2a024547"
import script from "./FluxoAprovacao.vue?vue&type=script&lang=js"
export * from "./FluxoAprovacao.vue?vue&type=script&lang=js"

import "./FluxoAprovacao.vue?vue&type=style&index=0&id=2a024547&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QPagination from 'quasar/src/components/pagination/QPagination.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QTable,QTd,QInput,QPagination});
